import { LanguageType } from 'types/enums';
import { useSurveyContext } from '../components/SurveyContext';

export const SurveyExpiredPinPage = () => {
	const { language } = useSurveyContext();
	const dictionary = DICTIONARY[language];

	return (
		<>
			<div className="flex flex-col p-8 sm:pt-12 md:pt-20 md:w-[756px] mx-auto">
				<div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6 bg-white rounded-lg shadow-normal">
					<h1 className="text-2xl sm:text-4xl font-semibold">
						{dictionary.expiredPinCode}
					</h1>
					<p className="text-sm sm:text-lg">{dictionary.description1}</p>
					<p className="text-sm sm:text-lg">{dictionary.description2}</p>
				</div>
			</div>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		expiredPinCode: 'Pin code expired',
		description1: 'The pin code you entered has expired.',
		description2: 'Please contact your provider for a new pin code.'
	},
	[LanguageType.Norwegian]: {
		expiredPinCode: 'Pin-kode utløpt',
		description1: 'Pin-koden du skrev inn har utløpt.',
		description2: 'Vennligst be om en ny pin-kode.'
	}
};
